<template>
  <svg
    width="31"
    height="34"
    viewBox="0 0 31 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1538 11H13H1.3C1.13431 11 1 11.1343 1 11.3V27.5C1 27.6657 1.13431 27.8 1.3 27.8H7H11.5396C11.7301 27.8 11.8723 27.9752 11.8332 28.1616L10.9791 32.2331C10.9226 32.5024 11.2282 32.6993 11.4501 32.5366L17.8299 27.8581C17.8813 27.8203 17.9435 27.8 18.0073 27.8H24.7C24.8657 27.8 25 27.6657 25 27.5V22.6083V17.4167"
      stroke="white"
      stroke-width="1.5"
    />
    <circle cx="7.5" cy="20.5" r="1.5" fill="white" />
    <circle cx="12.5" cy="20.5" r="1.5" fill="white" />
    <circle cx="17.5" cy="20.5" r="1.5" fill="white" />
    <rect x="18" width="13" height="16.25" rx="0.5" fill="white" />
    <path
      d="M19.626 2.29818C19.626 2.1186 19.707 1.94638 19.8513 1.81941C19.9955 1.69243 20.1911 1.62109 20.3951 1.62109H28.0868C28.2908 1.62109 28.4864 1.69243 28.6307 1.81941C28.7749 1.94638 28.856 2.1186 28.856 2.29818C28.856 2.47775 28.7749 2.64997 28.6307 2.77695C28.4864 2.90392 28.2908 2.97526 28.0868 2.97526H20.3951C20.1911 2.97526 19.9955 2.90392 19.8513 2.77695C19.707 2.64997 19.626 2.47775 19.626 2.29818Z"
      fill="#213e7a"
      fill-opacity="0.92"
    />
    <path
      d="M19.626 5.27865C19.626 5.09907 19.707 4.92685 19.8513 4.79988C19.9955 4.6729 20.1911 4.60156 20.3951 4.60156H28.0868C28.2908 4.60156 28.4864 4.6729 28.6307 4.79988C28.7749 4.92685 28.856 5.09907 28.856 5.27865C28.856 5.45822 28.7749 5.63044 28.6307 5.75742C28.4864 5.88439 28.2908 5.95573 28.0868 5.95573H20.3951C20.1911 5.95573 19.9955 5.88439 19.8513 5.75742C19.707 5.63044 19.626 5.45822 19.626 5.27865Z"
      fill="#213e7a"
      fill-opacity="0.92"
    />
    <path
      d="M20.3951 10.5586C20.1911 10.5586 19.9955 10.6299 19.8513 10.7569C19.707 10.8839 19.626 11.0561 19.626 11.2357C19.626 11.4153 19.707 11.5875 19.8513 11.7144C19.9955 11.8414 20.1911 11.9128 20.3951 11.9128H28.0868C28.2908 11.9128 28.4864 11.8414 28.6307 11.7144C28.7749 11.5875 28.856 11.4153 28.856 11.2357C28.856 11.0561 28.7749 10.8839 28.6307 10.7569C28.4864 10.6299 28.2908 10.5586 28.0868 10.5586H20.3951Z"
      fill="#213e7a"
      fill-opacity="0.92"
    />
    <path
      d="M20.3951 7.57812C20.1911 7.57812 19.9955 7.64946 19.8513 7.77644C19.707 7.90342 19.626 8.07563 19.626 8.25521C19.626 8.43478 19.707 8.607 19.8513 8.73398C19.9955 8.86096 20.1911 8.93229 20.3951 8.93229H28.0868C28.2908 8.93229 28.4864 8.86096 28.6307 8.73398C28.7749 8.607 28.856 8.43478 28.856 8.25521C28.856 8.07563 28.7749 7.90342 28.6307 7.77644C28.4864 7.64946 28.2908 7.57812 28.0868 7.57812H20.3951Z"
      fill="#213e7a"
      fill-opacity="0.92"
    />
    <path
      d="M19.626 14.2044C19.626 14.0249 19.711 13.8526 19.8624 13.7257C20.0137 13.5987 20.219 13.5273 20.4331 13.5273H23.6614C23.8754 13.5273 24.0807 13.5987 24.2321 13.7257C24.3834 13.8526 24.4685 14.0249 24.4685 14.2044C24.4685 14.384 24.3834 14.5562 24.2321 14.6832C24.0807 14.8102 23.8754 14.8815 23.6614 14.8815H20.4331C20.219 14.8815 20.0137 14.8102 19.8624 14.6832C19.711 14.5562 19.626 14.384 19.626 14.2044Z"
      fill="#213e7a"
      fill-opacity="0.92"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMessageNote',
};
</script>

<style></style>
